import script from "./transportPayDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./transportPayDetail.vue?vue&type=script&setup=true&lang=js"

import "./transportPayDetail.vue?vue&type=style&index=0&id=516fc8f8&lang=less"

const __exports__ = script;

export default __exports__